// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_p1-0";